import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as impact from '../common/api/impact';
import LandingPage from "./pages/LandingPage";
import ImpactPage from "./pages/ImpactPage";
import { merchantCode, oneOffConfig } from "./utils/oneOffConfig";

function App() {
  const [fetchedImpact, setfetchedImpact] = useState();
  const [oneOfConfig, setOneOfConfig] = useState(null);

  useEffect(() => {
    oneOffConfig().then(result => setOneOfConfig(result));
  }, []);

  useEffect(() => {
    impact.merchants(merchantCode)
      .then(response => response.json())
      .then(body => {
        setfetchedImpact(body)
      })
      .catch(error => {
        setfetchedImpact(error)
      })
  }, []);

  return (
    <>

      <Switch>
        <Route
          exact
          path={`/impact`}
          key="app-uniqway-offsetting-program-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/`}
          key="app-uniqway-offsetting-program-landing"
        >
          <LandingPage fetchedImpact={fetchedImpact} merchantCode={merchantCode} oneOfConfig={oneOfConfig} />
        </Route>
      </Switch>
    </>
  );
}

export default App;
